import { Injectable } from '@angular/core';
import { HttpRestService } from '@core/services/http-rest.service';
import { ContactSupport } from '@core/typings/ui/support.typing';

@Injectable({ providedIn: 'root' })
export class SupportResources {

  constructor (
    private http: HttpRestService
  ) { }

   sendSalesForceTicket (payload: ContactSupport.ContactSupportForApi) {
    return this.http.post(`api/support/SendSalesForceTicket`, payload);
  }
}
